'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var magicCommon = require('@gig/magic-common');
var userPendingConsents = require('@gig/magic-sdk/dist/adapter/users/userPendingConsents');

var _a;
var MINIMUM_AGE = 18;
var CONTENT_GROUPS = (_a = {},
    _a[userPendingConsents.ConsentName.TERMS] = 'terms',
    _a[userPendingConsents.ConsentName.PRIVACY_COOKIE_POLICY] = 'terms',
    _a._rest = 'marketing',
    _a);
var getConsentGroup = function (consentName) {
    if (CONTENT_GROUPS.hasOwnProperty(consentName)) {
        return CONTENT_GROUPS[consentName];
    }
    return CONTENT_GROUPS.hasOwnProperty('_rest') ? CONTENT_GROUPS._rest : '';
};
var interpolateConsent = function (consent, name, value) {
    var _a;
    return (tslib.__assign(tslib.__assign({}, consent), { consentContents: tslib.__assign(tslib.__assign({}, consent.consentContents), { header: magicCommon.interpolate(consent.consentContents.header, (_a = {},
                _a[name] = value,
                _a)) }) }));
};
(function (EGroupCheckboxState) {
    EGroupCheckboxState[EGroupCheckboxState["CHECKED"] = 0] = "CHECKED";
    EGroupCheckboxState[EGroupCheckboxState["UNCHECKED"] = 1] = "UNCHECKED";
    EGroupCheckboxState[EGroupCheckboxState["INDETERMINATE"] = 2] = "INDETERMINATE";
})(exports.EGroupCheckboxState || (exports.EGroupCheckboxState = {}));
var calculateConsentGroupState = function (consents) {
    var filteredConsents = consents === null || consents === void 0 ? void 0 : consents.filter(function (consent) { return consent.name !== userPendingConsents.ConsentName.DETAILS_REVERIFICATION; });
    if (!(filteredConsents === null || filteredConsents === void 0 ? void 0 : filteredConsents.length)) {
        return exports.EGroupCheckboxState.UNCHECKED;
    }
    var allChecked = true;
    var atLeastOneChecked = false;
    for (var _i = 0, consents_1 = consents; _i < consents_1.length; _i++) {
        var consent = consents_1[_i];
        var isChecked = consent.consented;
        var subState = consent.subConsents
            ? calculateConsentGroupState(consent.subConsents)
            : null;
        if (isChecked || subState === exports.EGroupCheckboxState.CHECKED) {
            atLeastOneChecked = true;
        }
        if (!isChecked || subState === exports.EGroupCheckboxState.UNCHECKED) {
            allChecked = false;
        }
        if (subState === exports.EGroupCheckboxState.INDETERMINATE) {
            return exports.EGroupCheckboxState.INDETERMINATE;
        }
    }
    if (allChecked) {
        return exports.EGroupCheckboxState.CHECKED;
    }
    if (atLeastOneChecked) {
        return exports.EGroupCheckboxState.INDETERMINATE;
    }
    return exports.EGroupCheckboxState.UNCHECKED;
};

exports.CONTENT_GROUPS = CONTENT_GROUPS;
exports.MINIMUM_AGE = MINIMUM_AGE;
exports.calculateConsentGroupState = calculateConsentGroupState;
exports.getConsentGroup = getConsentGroup;
exports.interpolateConsent = interpolateConsent;
